export const getResumablePrintPayments = (payments) =>
  (Array.isArray(payments) ? payments : []).filter(
    (payment) => payment.schemaVersion === 2 && payment.paymentStatus === 'awaiting_payment'
  );
